import Editorial from "./Editorial";
import BoldBlock from "./BoldBlock";
import MinimalCard from "./MinimalCard";
import Split from "./Split";
import Arch from "./Arch";
import PhotoOverlay from "./PhotoOverlay";

export const TEMPLATES = [
  {
    id: "editorial",
    name: "Editorial",
    description: "Cream panel, serif headline, sweeping photo cut, values strip",
    Component: Editorial,
  },
  {
    id: "bold",
    name: "Bold Block",
    description: "Forest background, circular headshot, big sans type",
    Component: BoldBlock,
  },
  {
    id: "minimal",
    name: "Minimal Card",
    description: "White canvas, hairline frame, centered rounded photo",
    Component: MinimalCard,
  },
  {
    id: "split",
    name: "Split",
    description: "Full-height photo left, stacked type on forest right",
    Component: Split,
  },
  {
    id: "arch",
    name: "Arch",
    description: "Soft gradient, arch-shaped photo, pill tags",
    Component: Arch,
  },
  {
    id: "overlay",
    name: "Photo Overlay",
    description: "Full-bleed photo with type over a dark gradient",
    Component: PhotoOverlay,
  },
];

export const TEMPLATE_BY_ID = Object.fromEntries(TEMPLATES.map((t) => [t.id, t]));
